import { render, staticRenderFns } from "./paiming.vue?vue&type=template&id=79011e36&scoped=true"
import script from "./paiming.vue?vue&type=script&lang=js"
export * from "./paiming.vue?vue&type=script&lang=js"
import style0 from "./paiming.vue?vue&type=style&index=0&id=79011e36&prod&lang=css"
import style1 from "./paiming.vue?vue&type=style&index=1&id=79011e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79011e36",
  null
  
)

export default component.exports